import { render, staticRenderFns } from "./imageClipper.vue?vue&type=template&id=518c7c3e&"
import script from "./imageClipper.vue?vue&type=script&lang=js&"
export * from "./imageClipper.vue?vue&type=script&lang=js&"
import style0 from "./imageClipper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports